import { BaseEntity } from './base-entity.model';

export enum CouponTypes {
  PERCENTAGE = "PERCENTAGE",
  AMOUNT = "AMOUNT"
}

export class Coupon extends BaseEntity {
  code: string;
  enabled: boolean;
  value: number;
  expire: number;
  type: CouponTypes;
  notes: string;
  limit: number | null;
}
